<template>
<div>
  <van-tabbar route>
    <van-tabbar-item  :to="{ name: 'index'}" icon="home-o" style="font-size: 18px">首页</van-tabbar-item>
    <van-tabbar-item  :to="{ name: 'orderlist'}" icon="bill-o" style="font-size: 18px">订单</van-tabbar-item>
    <!--<van-tabbar-item  :to="{ name: 'mine'}" icon="idcard" :badge="slot">证件管理</van-tabbar-item>-->
    <van-tabbar-item v-if="showMineTab" class="step1" :to="{ name: 'mine'}" icon="user-o" :badge="slot" style="font-size: 18px">我的</van-tabbar-item>
  </van-tabbar>
</div>
</template>
<script>
import api from "@/fetch/api"
import { Toast } from 'vant'
export default{
  data(){
    return {
      slot: '',
    }
  },
  // showMineTab 改为 computed 实时读 store；
  // 之前是 data 字段只在 created 初始化时读一次，导致 indexHome.vue 后续
  // commit('set_showMineTab') 不生效，「我的」tab 一直显示。
  computed: {
    showMineTab() {
      return this.$store.state.showMineTab;
    },
  },
  created()
  {
    this.getBindVehicleState();
  },
  methods:{
    getBindVehicleState() {
      var openid = this.$store.state.wx_info.openid;
      var that = this;
      api.getBindVehicleState(openid).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          that.$data.vehicleState = res.data.yhzt;
          var yhcgbazt = res.data.yhcgbazt || res.data.yhcsbazt;
          var yhctbazt = res.data.yhctbazt;
          var yhjsybazt = res.data.yhjsybazt;
          var yhyyybazt = res.data.yhyyybazt;
          var slot = 0;
          // 0=未绑定 1=未提交 2=待审核 3=审核成功；非 3 都计入角标
          if (yhcgbazt !== '3') slot++;
          if (yhctbazt !== '3') slot++;
          if (yhjsybazt !== '3') slot++;
          if (yhyyybazt !== '3') slot++;
          if(slot==0) slot = '';
          that.slot = slot;

          // 新司机 AI 对话危货绑定流程：getstate 确认车辆已绑定后再显示「我的」tab
          if (that.$store.state.aiChatVehicleBound) {
            var isVehicleBound = (yhctbazt && yhctbazt !== '0') || (yhcgbazt && yhcgbazt !== '0');
            that.$store.commit('set_showMineTab', isVehicleBound);
          }
        }
      }).catch(function() {
        Toast.fail('连接失败，请刷新页面');
      });
    },
  }
}
</script>
